module.exports = __webpack_public_path__ + "static/media/sphygmomanometer.403000ba.svg";